import React, { useEffect } from "react";

import useState from "react-usestateref";

import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@material-ui/core";
// import Pagination from "react-js-pagination";
import Pagination from "@material-ui/lab/Pagination";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
import moment from "moment";
import useStyles from "../components/Header/styles";
import SearchBar from "./searchbar";
import { RxCrossCircled } from "react-icons/rx";
import * as Icons from "@material-ui/icons";
import Skeleton from "react-skeleton-loader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CsvDownloader from "react-csv-downloader";
import ToDatePicker from "./todatepicker";
import FromDatePicker from "./fromdatepicker";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  border: "none",
  // p: 4,
};

function Contact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [beleafContact, setbeleafContact, beleafContactref] = useState([]);
  const [
    blockSentinalsContact,
    setblockSentinalsContact,
    blockSentinalsContactref,
  ] = useState([]);
  const [beleafblogcontacts, setbeleafblogcontacts, beleafblogcontactsref] =
    useState([]);
  const [blockblogcontacts, setblockblogcontacts, blockblogcontactsref] =
    useState([]);
  const [activefilter, setActivefilter] = useState(false);
  const [exportData, setexportData, exportDataref] = useState([]);
  const [blockexportData, setblockexportData, blockexportDataref] = useState(
    [],
  );
  const [
    beleafblogexportData,
    setbeleafblogexportData,
    beleafblogexportDataref,
  ] = useState([]);
  const [blockblogexportData, setblockblogexportData, blockblogexportDataref] =
    useState([]);
  const [activeData, setactiveData, activeDataref] =
    useState("Beleaf Contacts");

  const [totalPage, setTotalpages] = useState(0);
  var classes = useStyles();
  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const [open, setOpen] = useState(false);
  const [viewcontact, setviewcontact] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [validopen, setvalidOpen] = useState(false);

  const handlevalidOpen = () => setvalidOpen(true);
  const handlevalidClose = () => setvalidOpen(false);

  const changeStatus = async (value) => {
    var payload = {
      _id: viewcontact._id,
      status: value,
    };
    var data = {
      apiUrl: apiService.changeContactstatus,
      payload: payload,
    };

    var resp = await postMethod(data);
    if (resp.success == true) {
      toast.success(resp.Message);
      getContacts();
      handlevalidClose();
    } else {
      toast.error(resp.Message);
    }
  };
  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    getBlockContacts(pageNumber);
    getbeleafblogContacts(pageNumber);
    getblockblogContacts(pageNumber);
    setCurrentPage(pageNumber);
  };
  
  const [pageloader, setpageloader] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getContacts();
    getBlockContacts();
    getbeleafblogContacts();
    getblockblogContacts();
  }, []);

  const getContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.getBeleafInvalidcontacts,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.success == true) {
        console.log(resp.exportdata, "resp.data.data");
        setbeleafContact(resp.data.data);
        const formattedData = resp.exportdata.map((item, index) => ({
          Name: item.userName || "-",
          Email: item.email || "-",
          "Mobile Number": item.mobileNumber || "-",
          Message: item.comments || "-",
          Country: item.country,
          Medium: item.medium,
          Date: item.createdAt
            ? new Date(moment(item.createdAt).format("lll"))
            : "-",
        }));
        setexportData(formattedData);
        setTotalpages(resp.data.pages);
      } else {
        setbeleafContact([]);
        setexportData([]);
        setTotalpages(0);
      }
    } catch (error) {}
  };
  const getBlockContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.newnblockformInvalidcontact,
        payload: payload,
      };
      console.log(data);
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setblockSentinalsContact(resp.data.data);
        const formattedData = resp.data.exportData.map((item, index) => ({
          "Name ": item.userName,
          Medium: item.medium,
          "Medium Value": item.mediumvalue,
          "Mobile Number": item.mobileNumber,
          Country: item.country,
          "Message ": item.comments,
          "Received Date ": moment(item.createdAt).format("lll"),
        }));
        setblockexportData(formattedData);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {
      console.log("err", error);
    }
  };

  const getbeleafblogContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.get_beleaf_Invalid_blog_contacts,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setbeleafblogcontacts(resp.data.data);
        const formattedData = resp.data.exportData.map((item, index) => ({
          "Name ": item.name,
          Email: item.email,
          "Mobile Number": item.mobileNumber,
          Country: item.country,
          "Message ": item.comments,
          "Received Date ": moment(item.createdAt).format("lll"),
        }));
        setbeleafblogexportData(formattedData);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };
  // const  = async (page, search = "") => {
  //   try {
  //     var payload = {
  //       perpage: 10,
  //       page: page,
  //       search,
  //         fromDate: fromDate,
  //       toDate: toDate,
  //     };
  //     var data = {
  //       apiUrl: apiService.,
  //       payload: payload,
  //     };
  //     setpageloader(true);
  //     var resp = await postMethod(data);
  //     setpageloader(false);
  //     if (resp.success == true) {
  //       console.log(resp.data.data, "resp.data.data");
  //       (resp.data.data);
  //       setTotalpages(resp.data.pages);
  //     } else {
  //       setbeleafblogcontacts([]);
  //       setTotalpages(0);
  //     }
  //   } catch (error) {}
  // };
  const getblockblogContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
      };
      var data = {
        apiUrl: apiService.get_block_Invalid_blog_contacts,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.success == true) {
        console.log(resp.data.data, "resp.data.data");
        setblockblogcontacts(resp.data.data);
        setblockblogexportData(resp.data.csvData);
        setTotalpages(resp.data.pages);
      } else {
        setblockblogcontacts([]);
        setTotalpages(0);
      }
    } catch (error) {}
  };
  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getContacts(1);
    await getBlockContacts(1);
    await getbeleafblogContacts(1);
    await getblockblogContacts(1);
  };

  const download = async () => {
    if (exportDataref.current.length > 0) {
      toast.success("Beleaf contacts download succesfully");
    } else {
      toast.error("No record found");
    }
  };

  const downloadBlocksentinals = async () => {
    if (blockexportDataref.current.length > 0) {
      toast.success("Blocksentinals contacts download succesfully");
    } else {
      toast.error("No record found");
    }
  };
  const downloadbeleafBlog = async () => {
    if (beleafblogexportDataref.current.length > 0) {
      toast.success("Beleaf Blog contacts download succesfully");
    } else {
      toast.error("No record found");
    }
  };
  const downloadblockBlog = async () => {
    if (blockblogexportDataref.current.length > 0) {
      toast.success("Blocksentinals Blog contacts download succesfully");
    } else {
      toast.error("No record found");
    }
  };

  const changeTab = async (value) => {
    setactiveData(value);
    //    setSearchTerm("");
    // setFromDate("");
    // setToDate("");
    await getContacts(1);
    await getBlockContacts(1);
    await getbeleafblogContacts(1);
    await getblockblogContacts(1);
  };

  return (
    <>
      {/* {pageloader==true ?
        <>
            <div className="loader"><CircularProgress/></div>
        </>: */}
      <div>
        <div className="contact_tab_wrap">
          <div
            fullWidth
            color="inherit"
            className={`${
              activeDataref.current == "Beleaf Contacts"
                ? "invalidhead active"
                : "invalidhead"
            }`}
            variant="body2"
            sx={{ mt: 1 }}
            onClick={() => changeTab("Beleaf Contacts")}
          >
            Beleaf Contacts
          </div>
          <p
            fullWidth
            color="inherit"
            className={`${
              activeDataref.current == "Blocksentinals Contacts"
                ? "invalidhead active"
                : "invalidhead"
            }`}
            variant="body2"
            sx={{ mt: 1 }}
            onClick={() => changeTab("Blocksentinals Contacts")}
          >
            Blocksentinals Contacts
          </p>
          <p
            fullWidth
            color="inherit"
            className={`${
              activeDataref.current == "Beleaf Blog Contacts"
                ? "invalidhead active"
                : "invalidhead"
            }`}
            variant="body2"
            sx={{ mt: 1 }}
            onClick={() => changeTab("Beleaf Blog Contacts")}
          >
            Beleaf Blog Contacts
          </p>
          <p
            fullWidth
            color="inherit"
            className={`${
              activeDataref.current == "Blocksentinals Blog Contacts"
                ? "invalidhead active"
                : "invalidhead"
            }`}
            onClick={() => changeTab("Blocksentinals Blog Contacts")}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Blocksentinals Blog Contacts
          </p>
        </div>
        {activeDataref.current == "Beleaf Contacts" ? (
          <div className="right_top_invalid justify-content-end">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term, "Name")}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>

            <div onClick={download}>
              <CsvDownloader
                filename="Beleaf Contacts"
                extension=".csv"
                separator=","
                wrapColumnChar={`"`}
                datas={exportDataref.current}
                className="csvbutton"
                disabled={!(exportDataref.current?.length > 0)}
              >
                <i className="fas fa-file-excel"></i> Export
              </CsvDownloader>
            </div>
          </div>
        ) : activeDataref.current == "Blocksentinals Contacts" ? (
          <div className="right_top_invalid justify-content-end">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term, "Name")}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>

            <div onClick={downloadBlocksentinals}>
              <CsvDownloader
                filename="Blocksentinals Contacts"
                extension=".csv"
                separator=","
                wrapColumnChar={`"`}
                datas={blockexportDataref.current}
                className="csvbutton"
                disabled={!(blockexportDataref.current?.length > 0)}
              >
                <i className="fas fa-file-excel"></i> Export
              </CsvDownloader>
            </div>
          </div>
        ) : activeDataref.current == "Beleaf Blog Contacts" ? (
          <div className="right_top_invalid justify-content-end">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term, "Name")}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>

            <div onClick={downloadbeleafBlog}>
              <CsvDownloader
                filename="Beleaf Blog Contacts"
                extension=".csv"
                separator=","
                wrapColumnChar={`"`}
                datas={beleafblogexportDataref.current}
                className="csvbutton"
                disabled={!(beleafblogexportDataref.current?.length > 0)}
              >
                <i className="fas fa-file-excel"></i> Export
              </CsvDownloader>
            </div>
          </div>
        ) : (
          <div className="right_top_invalid justify-content-end">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term, "Name")}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>

            <div onClick={downloadblockBlog}>
              <CsvDownloader
                filename="Blocksentinals Blog Contacts"
                extension=".csv"
                separator=","
                wrapColumnChar={`"`}
                datas={blockblogexportDataref.current}
                className="csvbutton"
                disabled={!(blockblogexportDataref.current?.length > 0)}
              >
                <i className="fas fa-file-excel"></i> Export
              </CsvDownloader>
            </div>
          </div>
        )}
        {activeDataref.current == "Beleaf Contacts" ? (
          <>
            <div className="table_outer">
              <div className="table-responsive">
                <table class="table m-0 table-striped">
                  <thead className="admin_thead">
                    <tr>
                      <th> S.No</th>
                      <th> Name </th>
                      <th> Email</th>
                      <th> Mobile Number</th>
                      <th> Message </th>
                      <th> Country </th>
                      <th> Date </th>
                      <th> Medium </th>
                      <th> Status </th>
                      <th> Validity Status </th>
                      <th> View </th>
                    </tr>
                  </thead>

                  <tbody className="admin_tbody">
                    {" "}
                    {pageloader === true ? (
                      Array.from({ length: 10 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : beleafContactref.current.length > 0 ? (
                      beleafContactref.current &&
                      beleafContactref.current.map((orders, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{orders.userName.substring(0, 15)}</td>
                            <td>{orders.email}</td>
                            <td>{orders.mobileNumber}</td>
                            <td>{orders.comments.substring(0, 15)}...</td>
                            <td>{orders.country}</td>
                            <td>{moment(orders.createdAt).format("lll")}</td>
                            <td>{orders.medium}</td>
                            <td>
                              {orders.readStatus == "notread" ? (
                                <p className="mb-0" style={{ color: "green" }}>
                                  {" "}
                                  Open{" "}
                                </p>
                              ) : (
                                <p className="mb-0" style={{ color: "red" }}>
                                  {" "}
                                  Closed{" "}
                                </p>
                              )}
                            </td>
                            <td>
                              {orders.contactStatus === "active" ? (
                                <p
                                  className="mb-0 cursor-pointer"
                                  style={{ color: "blue", Cursor: "pointer" }}
                                >
                                  Active
                                </p>
                              ) : orders.contactStatus === "Valid" ? (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "green",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Valid
                                </p>
                              ) : (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "red",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Invalid
                                </p>
                              )}
                            </td>
                            <td
                              onClick={() => {
                                handleOpen();
                                setviewcontact(orders);
                              }}
                              className="cursor-pointer"
                            >
                              <i class="fa-solid fa-eye cursor-pointer" />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="no-record">
                        <td colSpan={11}>
                          <div className="emptyrecordimg">
                            <img
                              src={require("../images/No-data.webp")}
                              width="100px"
                            />
                            <span className="emptyrecord">
                              No records found
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <Pagination
              count={totalPage}
              page={currentPage}
              onChange={(e, value) => handlePageChange(value)}
              className={`${classes.blog_pagination} mt-4`}
              color="primary"
              shape="rounded"
            />
          </>
        ) : activeDataref.current == "Blocksentinals Contacts" ? (
          <>
            <div className="table_outer">
              <div className="table-responsive">
                <table class="table table-striped textwraping">
                  <thead className="admin_thead">
                    <tr>
                      <th> S.No</th>
                      <th> Name </th>
                      <th> Medium</th>
                      <th> Medium Value</th>
                      <th> Mobile Number</th>
                      <th> Country</th>
                      <th> Message </th>
                      <th> Received Date </th>
                      <th> Status </th>
                      <th> Validity Status </th>
                    </tr>
                  </thead>
                  <tbody className="admin_tbody">
                    {pageloader === true ? (
                      Array.from({ length: 10 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : blockSentinalsContactref.current.length > 0 ? (
                      blockSentinalsContactref.current &&
                      blockSentinalsContactref.current.map((orders, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              {orders.userName.substring(0, 15)}{" "}
                              {orders.length > 10 ? "..." : ""}
                            </td>
                            <td>{orders.medium}</td>
                            <td>{orders.mediumvalue}</td>
                            <td>{orders.mobileNumber}</td>
                            <td>{orders.country}</td>
                            <td>{orders.comments.substring(0, 15)}...</td>
                            <td>{moment(orders.createdAt).format("lll")}</td>
                            <td
                              onClick={() => {
                                handleOpen();
                                setviewcontact(orders);
                              }}
                            >
                              <i class="fa-solid fa-eye  cursor-pointer"></i>
                            </td>
                            <td>
                              {orders.contactStatus === "active" ? (
                                <p
                                  className="mb-0 cursor-pointer"
                                  style={{ color: "blue", Cursor: "pointer" }}
                                  onClick={() => {
                                    handlevalidOpen();
                                    setviewcontact(orders);
                                  }}
                                >
                                  Active
                                </p>
                              ) : orders.contactStatus === "Valid" ? (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "green",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Valid
                                </p>
                              ) : (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "red",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Invalid
                                </p>
                              )}
                            </td>

                            {/* <td>
                            {orders.readStatus == "notread" ? (
                              <p
                                style={{ color: "green" }}
                                onClick={() => enquiry(orders)}
                              >
                                {" "}
                                Open{" "}
                              </p>
                            ) : (
                              <p style={{ color: "red" }}> Closed </p>
                            )}
                          </td> */}
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="no-record">
                        <td colSpan={12}>
                          <div className="emptyrecordimg">
                            <img
                              src={require("../images/No-data.webp")}
                              width="100px"
                            />
                            <span className="emptyrecord">
                              No records found
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              count={totalPage}
              page={currentPage}
              onChange={(e, value) => handlePageChange(value)}
              className={`${classes.blog_pagination} mt-4`}
              color="primary"
              shape="rounded"
            />
          </>
        ) : activeDataref.current == "Beleaf Blog Contacts" ? (
          <>
            <div className="table_outer">
              <div className="table-responsive">
                <table class="table table-striped">
                  <thead className="admin_thead">
                    <tr>
                      <th> S.No</th>
                      <th> Name </th>
                      <th> Email</th>
                      <th> Mobile Number</th>
                      <th> Message </th>
                      <th> Country </th>
                      <th> Date </th>
                      <th> Status </th>
                      <th> Validity Status </th>
                      <th> View</th>
                    </tr>
                  </thead>

                  <tbody className="admin_tbody">
                    {pageloader === true ? (
                      Array.from({ length: 10 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : beleafblogcontactsref.current.length > 0 ? (
                      beleafblogcontactsref.current &&
                      beleafblogcontactsref.current.map((orders, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{orders.name}</td>
                            <td>{orders.email}</td>
                            <td>{orders.mobileNumber || "-"}</td>
                            <td>{orders.comments.substring(0, 15)}</td>
                            <td>{orders.country}</td>
                            <td>{moment(orders.createdAt).format("lll")}</td>
                            <td>
                              {orders.readStatus == "notread" ? (
                                <p className="mb-0" style={{ color: "green" }}>
                                  {" "}
                                  Open{" "}
                                </p>
                              ) : (
                                <p className="mb-0" style={{ color: "red" }}>
                                  {" "}
                                  Closed{" "}
                                </p>
                              )}
                            </td>
                            <td>
                              {orders.contactStatus === "active" ? (
                                <p
                                  className="mb-0 cursor-pointer"
                                  style={{ color: "blue", Cursor: "pointer" }}
                                  onClick={() => {
                                    handlevalidOpen();
                                    setviewcontact(orders);
                                  }}
                                >
                                  Active
                                </p>
                              ) : orders.contactStatus === "Valid" ? (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "green",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Valid
                                </p>
                              ) : (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "red",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Invalid
                                </p>
                              )}
                            </td>

                            <td
                              onClick={() => {
                                handleOpen();
                                setviewcontact(orders);
                              }}
                              className="cursor-pointer"
                            >
                              <i class="fa-solid fa-eye cursor-pointer" />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="no-record">
                        <td colSpan={10}>
                          <div className="emptyrecordimg">
                            <img
                              src={require("../images/No-data.webp")}
                              width="100px"
                            />
                            <span className="emptyrecord">
                              No records found
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {totalPage > 1 && (
              <Pagination
                count={totalPage}
                page={currentPage}
                onChange={(e, value) => handlePageChange(value)}
                className={`${classes.blog_pagination} mt-4`}
                color="primary"
                shape="rounded"
              />
            )}
          </>
        ) : (
          <>
            {" "}
            <div className="table_outer">
              <div className="table-responsive">
                <table class="table m-0 table-striped">
                  <thead className="admin_thead">
                    <tr>
                      <th> S.No</th>
                      <th> Name </th>
                      <th> Email</th>
                      <th> Mobile Number</th>
                      <th> Message </th>
                      <th> Country </th>
                      <th> Date </th>
                      <th> Status </th>
                      <th> Validity Status </th>
                      <th> View </th>
                    </tr>
                  </thead>

                  <tbody className="admin_tbody">
                    {pageloader === true ? (
                      Array.from({ length: 10 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : blockblogcontactsref.current.length > 0 ? (
                      blockblogcontactsref.current &&
                      blockblogcontactsref.current.map((orders, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{orders.name}</td>
                            <td>{orders.email}</td>
                            <td>{orders.mobileNumber}</td>
                            <td>{orders.comments}</td>
                            <td>{orders.country}</td>
                            <td>{moment(orders.createdAt).format("lll")}</td>

                            <td>
                              {orders.readStatus == "notread" ? (
                                <p className="mb-0" style={{ color: "green" }}>
                                  {" "}
                                  Open{" "}
                                </p>
                              ) : (
                                <p className="mb-0" style={{ color: "red" }}>
                                  {" "}
                                  Closed{" "}
                                </p>
                              )}
                            </td>
                            <td>
                              {orders.contactStatus === "active" ? (
                                <p
                                  className="mb-0 cursor-pointer"
                                  style={{ color: "blue", Cursor: "pointer" }}
                                  onClick={() => {
                                    handlevalidOpen();
                                    setviewcontact(orders);
                                  }}
                                >
                                  Active
                                </p>
                              ) : orders.contactStatus === "Valid" ? (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "green",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Valid
                                </p>
                              ) : (
                                <p
                                  className="mb-0"
                                  style={{
                                    color: "red",
                                    cursor: "not-allowed",
                                  }}
                                >
                                  Invalid
                                </p>
                              )}
                            </td>
                            <td
                              onClick={() => {
                                handleOpen();
                                setviewcontact(orders);
                              }}
                              className="cursor-pointer"
                            >
                              <i class="fa-solid fa-eye cursor-pointer" />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="no-record">
                        <td colSpan={9}>
                          <div className="emptyrecordimg">
                            <img
                              src={require("../images/No-data.webp")}
                              width="100px"
                            />
                            <span className="emptyrecord">
                              No records found
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {totalPage > 1 && (
              <Pagination
                count={totalPage}
                page={currentPage}
                onChange={(e, value) => handlePageChange(value)}
                className={`${classes.blog_pagination} mt-4`}
                color="primary"
                shape="rounded"
              />
            )}
          </>
        )}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_top">
              {/* <Icons.Cancel
                  className="cursor-pointer"
                  onClick={handleClose}
                /> */}
              <h5>Contact Information</h5>

              <RxCrossCircled
                className="modal_close_icon"
                onClick={handleClose}
              />
            </div>
            <div className="modal_bottom">
              <div className="modal_details">
                <h6>Name</h6>
                <p>{viewcontact.userName ? viewcontact.userName : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Email</h6>
                <p>{viewcontact.email ? viewcontact.email : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Mobile Number</h6>
                <p>
                  {viewcontact.mobileNumber ? viewcontact.mobileNumber : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Message</h6>
                <p>{viewcontact.comments ? viewcontact.comments : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Country</h6>
                <p>{viewcontact.country ? viewcontact.country : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Medium</h6>
                <p>{viewcontact.medium ? viewcontact.medium : "--"}</p>
              </div>
            </div>
            <div className="d-flex"></div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Contact;
